<template>
  <section>
    <div class="tip" style="margin:0 0 0 20px">* 项目基本资料</div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目编号">
          <el-input size="small" :disabled="true" placeholder="请输入项目编号" v-model="project.number"></el-input>
        </el-form-item>
        <el-col :span="12">
        </el-col>
      </el-col>
    </div>
    <el-form-item label="项目名称">
      <el-input size="small" v-model="project.name" :disabled="true" placeholder="请输入项目名称"></el-input>
    </el-form-item>
    <el-form-item label="项目需求单位">
      <el-input size="small" :disabled="true" v-model="project.deptName"></el-input>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目负责人">
          <el-input size="small" :disabled="true" v-model="project.leader.name"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系方式">
          <el-input size="small" :disabled="true" v-model="project.leader.mobile"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="一审结算价(元)">
          <el-input size="small" v-model="form.ysjsj" placeholder="请输入一审结算价(元)"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="一审审核单位">
          <el-input size="small" v-model="form.ysshdw" placeholder="请输入一审审核单位"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="二审结算价(元)">
          <el-input size="small" v-model="form.esjsj" placeholder="请输入二审结算价(元)"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="二审审核单位">
          <el-input size="small" v-model="form.esshdw" placeholder="请输入二审审核单位"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="财政局审核价(元)">
          <el-input size="small" v-model="form.czjshj" placeholder="财政局审核价(元)"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="审核单位">
          <el-input size="small" v-model="form.shdw" placeholder="请输入审核单位"></el-input>
        </el-form-item>
      </el-col>
    </div>
  </section>
</template>

<script>
  export default {
    props: ['project', 'formByFather', 'userData'],
    data() {
      return {
        form: {},
      }
    },
    mounted() {
      this.form = this.formByFather
    },
    methods: {
      getFromData() {
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/endRegister.vue